<template>
  <h2 class="large-text" :data-testid="testid"><slot></slot></h2>
</template>

<script>
export default {
  name: 'LargeText',
  props: {
    testid: {
      type: String,
      defaultValue: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.large-text {
  font-size: large;
  font-weight: bold;
}
</style>
